import heroMaster from "../../assets/hero-master.jpg";
import { colors } from "../../constants/theme";

export default function Hero() {
  return (
    <section
      id="hero"
      className="hero-section"
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#030805",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      {/* ── Background Master Artwork (Clean Left Side) ── */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${heroMaster})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: 0
        }}
      />

      {/* ── Responsive Content Container ── */}
      <style>{`
        .hero-stat-icon {
          width: 22px;
          height: 22px;
          flex: 0 0 22px;
          stroke: #d8f879;
          stroke-width: 1.7;
          stroke-linecap: round;
          stroke-linejoin: round;
          filter: drop-shadow(0 0 7px rgba(200, 241, 53, 0.28));
        }
        .hero-stat-icon-accent {
          stroke: #ffffff;
          stroke-width: 1.5;
        }
        @media (max-width: 860px) {
          .hero-grid {
            grid-template-columns: 1fr !important;
            width: 100% !important;
            padding: 5.2rem 14px 2rem !important;
            gap: 1.2rem !important;
            margin: 0 !important;
          }
          .hero-spacer {
            display: none !important;
          }
          .hero-content-card {
            max-width: 100% !important;
            width: 100% !important;
            background: rgba(3, 8, 5, 0.88) !important;
            backdrop-filter: blur(20px) !important;
            -webkit-backdrop-filter: blur(20px) !important;
            border-radius: 24px !important;
            padding: 1.6rem 1.25rem !important;
            border: 1px solid rgba(255, 255, 255, 0.13) !important;
            box-shadow: 0 24px 70px rgba(0, 0, 0, 0.38) !important;
          }
          .hero-h1 {
            font-size: clamp(2rem, 7.5vw, 3.4rem) !important;
            line-height: 1.02 !important;
          }
          .hero-p {
            font-size: 0.95rem !important;
            line-height: 1.55 !important;
            margin-top: 1rem !important;
          }
          .hero-btn-group {
            flex-direction: column !important;
            width: 100% !important;
            gap: 0.75rem !important;
          }
          .hero-btn-group a {
            width: 100% !important;
            justify-content: center !important;
            text-align: center !important;
            padding: 0.75rem 1.5rem !important;
          }
          .hero-stats-grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 0.5rem !important;
            margin-top: 1.8rem !important;
            padding-top: 1.2rem !important;
            text-align: center !important;
          }
          .hero-stat-sep {
            display: none !important;
          }
          .hero-stat-num {
            font-size: 1.15rem !important;
            justify-content: center !important;
          }
          .hero-stat-sub {
            font-size: 0.7rem !important;
          }
        }
        @media (max-width: 600px) {
          .hero-section {
            min-height: auto !important;
            align-items: flex-start !important;
          }
          .hero-section > div:first-child {
            background-position: 58% center !important;
          }
          .hero-grid {
            padding: 7.2rem 14px 8rem !important;
          }
          .hero-content-card {
            padding: 1.45rem 1rem 1.25rem !important;
          }
          .hero-h1 {
            font-size: clamp(2rem, 8vw, 2.6rem) !important;
            line-height: 1.04 !important;
            letter-spacing: -0.045em !important;
          }
          .hero-p {
            color: #c2ccda !important;
            font-size: 0.9rem !important;
            line-height: 1.55 !important;
            margin-top: 0.9rem !important;
          }
          .hero-btn-group {
            margin-top: 1.4rem !important;
            gap: 0.6rem !important;
          }
          .hero-btn-group a {
            min-height: 46px;
            padding: 0.7rem 1rem !important;
          }
          .hero-stats-grid {
            gap: 0.35rem !important;
            margin-top: 1.3rem !important;
            padding-top: 1rem !important;
          }
          .hero-stat-num {
            gap: 0.25rem !important;
            font-size: clamp(0.88rem, 3.7vw, 1.05rem) !important;
            white-space: nowrap;
          }
          .hero-stat-icon {
            width: 18px;
            height: 18px;
            flex-basis: 18px;
          }
          .hero-stat-num span {
            font-size: 1rem !important;
          }
          .hero-stat-sub {
            font-size: 0.62rem !important;
            line-height: 1.3;
            margin-top: 0.25rem !important;
          }
        }
        @media (max-width: 600px) and (max-height: 740px) {
          .hero-grid {
            padding-top: 6.4rem !important;
            padding-bottom: 3.5rem !important;
          }
        }
      `}</style>

      <div
        style={{
          position: "relative",
          zIndex: 2,
          width: "min(1380px, 92%)",
          margin: "0 auto",
          padding: "7rem 0 5.5rem",
          display: "grid",
          gridTemplateColumns: "1.15fr 0.85fr",
          alignItems: "center",
          gap: "2.5rem"
        }}
        className="hero-grid"
      >
        {/* ── Left Column: Real HTML Typography Matching Original Design ── */}
        <div style={{ maxWidth: 540 }} className="hero-content-card">
          
          {/* Headline (Exact font, weights, and lime color matching original image) */}
          <h1
            className="hero-h1"
            style={{
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              fontSize:   "clamp(3rem, 5.6vw, 5.1rem)",
              fontWeight: 900,
              lineHeight: 0.96,
              letterSpacing: "-0.04em",
              margin: 0,
              textRendering: "optimizeLegibility",
              WebkitFontSmoothing: "antialiased"
            }}
          >
            <span style={{ color: "#ffffff", display: "block" }}>Salud accesible,</span>
            <span style={{ color: "#f3f7e8", display: "block" }}>tecnología</span>
            <span style={{ color: "#c4f036", display: "block" }}>inteligente.</span>
          </h1>

          {/* Subtitle Paragraph */}
          <p
            className="hero-p"
            style={{
              marginTop:  "1.4rem",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize:   "clamp(1rem, 1.8vw, 1.12rem)",
              fontWeight: 400,
              color:      "#94a3b8",
              lineHeight: 1.65,
              maxWidth:   490,
              animation:  "fadeUp .7s .2s ease both",
            }}
          >
            Máquinas inteligentes con opciones nutritivas para acompañar cada entrenamiento y ayudarte a cuidar tu bienestar.
          </p>

          {/* Action Buttons */}
          <div
            className="hero-btn-group"
            style={{
              marginTop:  "2.2rem",
              display:    "flex",
              alignItems: "center",
              gap:        "1.2rem",
              flexWrap:   "wrap",
              animation:  "fadeUp .7s .3s ease both",
            }}
          >
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("objetivos")?.scrollIntoView({ behavior: "smooth" });
              }}
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                background: "#c8f135",
                color: "#050e08",
                fontWeight: 800,
                fontSize: "1.02rem",
                padding: ".85rem 2.2rem",
                borderRadius: 9999,
                boxShadow: "0 0 28px rgba(200, 241, 53, 0.45)",
                transition: "all .3s ease",
                display: "inline-flex",
                alignItems: "center",
                gap: ".55rem"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 0 38px rgba(200, 241, 53, 0.7)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 0 28px rgba(200, 241, 53, 0.45)";
              }}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                <line x1="12" y1="18" x2="12.01" y2="18" />
              </svg>
              Explorar Solución →
            </a>

            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("app")?.scrollIntoView({ behavior: "smooth" });
              }}
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                background: "rgba(10, 24, 15, 0.65)",
                border: "1.5px solid rgba(255, 255, 255, 0.2)",
                color: "#ffffff",
                fontWeight: 700,
                fontSize: ".98rem",
                padding: ".85rem 1.8rem",
                borderRadius: 9999,
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                transition: "all .3s ease",
                display: "inline-flex",
                alignItems: "center",
                gap: ".5rem"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = "#c8f135";
                e.currentTarget.style.color = "#c8f135";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.color = "#ffffff";
              }}
            >
              Ver la App
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </a>
          </div>

          {/* Live Stats Row (Tailored to Fitness & Gyms) */}
          <div
            className="hero-stats-grid"
            style={{
              marginTop: "3rem",
              display: "grid",
              gridTemplateColumns: "1fr auto 1fr auto 1fr",
              alignItems: "center",
              gap: "1.2rem",
              borderTop: "1px solid rgba(255, 255, 255, 0.12)",
              paddingTop: "1.8rem"
            }}
          >
            <div>
              <div className="hero-stat-num" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: "1.6rem", fontWeight: 800, color: "#ffffff", display: "flex", alignItems: "center", gap: ".4rem" }}>
                <svg className="hero-stat-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20c-4.2-2.8-6.3-5.3-6.3-8.1A3.4 3.4 0 0 1 12 9.7a3.4 3.4 0 0 1 6.3 2.2c0 2.8-2.1 5.3-6.3 8.1Z"/><path className="hero-stat-icon-accent" d="M12 9.7c-.9-1.6-1.1-3-.5-4.2M8.7 14.3c1.1.1 2.2-.2 3.3-.9m.1 4c1-.8 2.1-1.2 3.3-1.2"/></svg> 100%
              </div>
              <div className="hero-stat-sub" style={{ fontSize: ".8rem", color: "#94a3b8", marginTop: "2px", fontWeight: 500 }}>Productos frescos</div>
            </div>

            <div className="hero-stat-sep" style={{ width: 1, height: 38, background: "rgba(255, 255, 255, 0.12)" }} />

            <div>
              <div className="hero-stat-num" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: "1.6rem", fontWeight: 800, color: "#ffffff", display: "flex", alignItems: "center", gap: ".4rem" }}>
                <svg className="hero-stat-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3Z"/><path className="hero-stat-icon-accent" d="m9 12 2 2 4-4"/></svg> 100%
              </div>
              <div className="hero-stat-sub" style={{ fontSize: ".8rem", color: "#94a3b8", marginTop: "2px", fontWeight: 500 }}>Calidad y nutrición</div>
            </div>

            <div className="hero-stat-sep" style={{ width: 1, height: 38, background: "rgba(255, 255, 255, 0.12)" }} />

            <div>
              <div className="hero-stat-num" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: "1.6rem", fontWeight: 800, color: "#ffffff", display: "flex", alignItems: "center", gap: ".4rem" }}>
                <svg className="hero-stat-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m13.2 2.8-8 10.1a.8.8 0 0 0 .6 1.3h5l-.8 7 9.6-11.6a.8.8 0 0 0-.6-1.3h-5.4l-.4-5.5Z"/><path className="hero-stat-icon-accent" d="m8.1 12.1 3.4.2m3-3.7-.5 4.2"/></svg> 24/7
              </div>
              <div className="hero-stat-sub" style={{ fontSize: ".8rem", color: "#94a3b8", marginTop: "2px", fontWeight: 500 }}>Energía & Salud</div>
            </div>
          </div>

        </div>

        {/* ── Right Column Space for 3D Scene ── */}
        <div className="hero-spacer" style={{ minHeight: 450 }} />
      </div>
    </section>
  );
}
